import { authorizedApiClient } from "../config";
import {
  CreateSkillPayload,
  CustomSkill,
  GenerateSkillContentPayload,
  GenerateSkillContentResponse,
  SkillVersionSummary,
  UpdateSkillPayload,
} from "./skillsEndpoints.interface";

export const getWorkspaceSkills = async ({
  workspace_id,
}: {
  workspace_id: string;
}) =>
  authorizedApiClient.get<CustomSkill[]>(`/${workspace_id}/skills`);

export const getSkill = async ({
  workspace_id,
  skill_id,
}: {
  workspace_id: string;
  skill_id: string;
}) =>
  authorizedApiClient.get<CustomSkill>(`/${workspace_id}/skills/${skill_id}`);

export const createSkill = async ({
  workspace_id,
  ...data
}: CreateSkillPayload) =>
  authorizedApiClient.post<CustomSkill>(`/${workspace_id}/skills`, data);

export const updateSkill = async ({
  workspace_id,
  skill_id,
  ...data
}: UpdateSkillPayload) =>
  authorizedApiClient.patch<CustomSkill>(
    `/${workspace_id}/skills/${skill_id}`,
    data,
  );

export const deleteSkill = async ({
  workspace_id,
  skill_id,
}: {
  workspace_id: string;
  skill_id: string;
}) =>
  authorizedApiClient.delete<void>(`/${workspace_id}/skills/${skill_id}`);

export const toggleSkill = async ({
  workspace_id,
  skill_id,
  enabled,
}: {
  workspace_id: string;
  skill_id: string;
  enabled: boolean;
}) =>
  authorizedApiClient.patch<CustomSkill>(
    `/${workspace_id}/skills/${skill_id}`,
    { enabled },
  );

export const getSkillVersions = async ({
  workspace_id,
  skill_id,
}: {
  workspace_id: string;
  skill_id: string;
}) =>
  authorizedApiClient.get<SkillVersionSummary[]>(
    `/${workspace_id}/skills/${skill_id}/versions`,
  );

export const activateVersion = async ({
  workspace_id,
  skill_id,
  version_id,
}: {
  workspace_id: string;
  skill_id: string;
  version_id: string;
}) =>
  authorizedApiClient.post<CustomSkill>(
    `/${workspace_id}/skills/${skill_id}/versions/${version_id}/activate`,
  );

export const generateSkillContent = async ({
  workspace_id,
  prompt,
  existing_content,
}: GenerateSkillContentPayload) =>
  authorizedApiClient.post<GenerateSkillContentResponse>(
    `/${workspace_id}/skills/generate`,
    { prompt, existing_content },
  );

export const generateSkillDataQuery = async ({
  workspace_id,
  skill_id,
}: {
  workspace_id: string;
  skill_id: string;
}) =>
  authorizedApiClient.post(
    `/${workspace_id}/skills/${skill_id}/generate-data-query`,
  );
